var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('a',{staticClass:"skip-link",attrs:{"href":"#main-content"}},[_vm._v(_vm._s(_vm.$t('global.skipToContent')))]),_vm._v(" "),_c('TopNavigation'),_vm._v(" "),_c('main',{attrs:{"id":"main-content"}},[_c('Nuxt')],1),_vm._v(" "),(_vm.showCookieConsent)?_c('CookieConsent'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }